import User from '../../../base/errors/user';
import create from './Create';

const user: User = {
  create,
  notificationChannelUnableToLoad: 'Benachrichtigungskanal konnte nicht geladen werden'
};

export default user;
